import { render, staticRenderFns } from "./MyMediaAccreditationPassForm.vue?vue&type=template&id=60e71ff8&scoped=true"
import script from "./MyMediaAccreditationPassForm.vue?vue&type=script&lang=js"
export * from "./MyMediaAccreditationPassForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60e71ff8",
  null
  
)

export default component.exports